<template>
    <div>
      <img src="../../../assets/images/banner-500/joinus.jpg">
    </div>
</template>

<script>
    export default {
        name: "joinmainbanner"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/contentcoms/joincontentcoms/joinmainbanner.vue